'use strict';

import template from './city_list.html';

export default {
  template,
  bindings: {
    cityList: '<?',
    country: '<?',
  }
};



// WEBPACK FOOTER //
// ./app/src/modules/cities/city_list/city_list.js